import * as React from 'react';

const columnsBtc = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        selector: (row) => String(row.majority),
        sortable: true,
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
    },
    {
        id: 'FoldX',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: (row) => row.efoldx === null ? Number.POSITIVE_INFINITY : parseFloat(row.efoldx),
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsLowRisk = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsLowRiskNoFF = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    },
];

const columnsHighRisk = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsHighRiskNoFF = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    },
];

const columnsCombinedLowRisk = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
        width: '100px',
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '70px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '65px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        width: '120px',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsCombinedLowRiskNoFF = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
        width: '100px',
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '70px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '65px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        width: '120px',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    },
];

const columnsCombinedHighRisk = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '70px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '65px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        width: '120px',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsCombinedHighRiskNoFF = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '70px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '65px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        width: '120px',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '80px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    },
];

const columnsAncestralDesignTop = [
    {
        name: <span title="Identification of ancestral node in the phylogenetic tree.">Ancestral node</span>,
        selector: 'node',
        sortable: true,
    },   
    {
        name: <span title="Number of levels from the root of the phylogenetic tree.">Distance from root</span>,
        selector: 'distance',
        sortable: true,
    },
    {
        name: <span title="Number of mutations compared to query sequence.">Number of mutations</span>,
        selector: 'mutNum',
        sortable: true,
    },
];

const columnsAncestralDesigns = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '100px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        width: '100px',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        width: '100px',
        sortable: true,
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        width: '100px',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        sortable: true,
        width: '120px',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
    },
    {
        name: <span title="Mutations occurs in the following nodes of the phylogenetic tree.">Used in nodes</span>,
        selector: 'ancestrals',
        width: '250px',
        sortable: false,
    },

];

const columnsAllResidues = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
        width: '69px',
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '67px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '63px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
        sortable: true,
        width: '119px',
    },
    {
        id: 'bfactor',
        name: <span title="Flexibility score">BFactor</span>,
        selector: 'bfactor',
        sortable: true,
        width: '90px',
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '78px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '75px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        width: '80px',
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        width: '90px',
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
];

const columnsAllResiduesNoFF = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        width: '80px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
        width: '69px',
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        width: '67px',
    },
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        width: '63px',
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
        sortable: true,
        width: '119px',
    },
    {
        id: 'bfactor',
        name: <span title="Flexibility score">BFactor</span>,
        selector: 'bfactor',
        sortable: true,
        width: '90px',
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
        width: '78px',
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
        width: '75px',
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        width: '80px',
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    }
];

const columnsAllResiduesTop = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
    },
    {
        id: 'Residue',
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
    },
    {
        name: <span title="Mutability score: the lower the number, the more conserved the position is">Conservation</span>,
        selector: 'conservationScore',
        conditionalCellStyles: [
            {
                when: row => parseInt(row.conservationScore) < 4,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseInt(row.conservationScore) >= 4 && parseInt(row.conservationScore) < 7,
                style: {
                    color: 'orange'
                }                
            },
            {
                when: row => parseInt(row.conservationScore) >= 7,
                style: {
                    color: 'red'
                }
            }
        ],
        sortable: true,
    },
    {
        name: <span title="Correlation score - the higher the number, more likely the residue is correlated with another one.">Correlation</span>,
        selector: 'correlationScore',
        conditionalCellStyles: [
            {
                when: row => String(row.correlated) === "true",
                style: {
                    color: 'green'
                }
            },
            {
                when: row => String(row.correlated) === "false",
                style: {
                    color: 'red'
                }
            }
        ],
        sortable: true,
    },
    {
        id: 'bfactor',
        name: <span title="Flexibility score">BFactor</span>,
        selector: 'bfactor',
        sortable: true,
    },
    {
        id: 'used',
        name: <span title="Mutation occurs in at least one of the FireProt designs">Used in design</span>,
        selector: 'used',
        sortable: true,
        width: '130px',
    },
];

const columnsAllResiduesDown = [
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'Rosetta',
        name: <span title="Rosetta stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">Rosetta</span>,
        selector: 'erosetta',
        sortable: true,
        format: (row) => row.erosetta === null ? "-" : row.erosetta,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.erosetta) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.erosetta) >= 0.5,
                style: {
                    color: 'red'
                }                
            },
        ],
    },
    {
        id: 'btc',
        name: <span title="Mutation was identifies by evolutionary approach.">From evolution</span>,
        selector: (row) => String(row.btc),
        format: (row) => row.btc ? "YES" : "NO",
        sortable: true,
    },
    {
        id: 'isHighEnergy',
        name: <span title="Mutation was identifies by energetic approach.">From energy</span>,
        selector: (row) => String(row.isHighEnergy),
        format: (row) => row.isHighEnergy || row.isLowEnergy ? "YES" : "NO",
        sortable: true,
    },
];

const columnsAllResiduesDownNoFF = [
    {
        id: 'Mutation',
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
    },
    {
        id: 'byMajority',
        name: <span title="Identified by back-to-consensus analysis using majority approach.">Majority</span>,
        selector: (row) => String(row.majority),
        format: (row) => String(row.majority) === "false" ? "NO" : "YES",
        sortable: true,
    },
    {
        id: 'byRatio',
        name: <span title="Identified by back-to-consensus analysis using ratio approach.">Ratio</span>,
        selector: (row) => String(row.ratio),
        format: (row) => String(row.ratio) === "false" ? "NO" : "YES",
        sortable: true,
    },
    {
        id: 'Foldx',
        name: <span title="FoldX stability prediction [kcal/mol]. Lower ddG represents higher stabilization.">FoldX</span>,
        selector: 'efoldx',
        sortable: true,
        format: (row) => row.efoldx === null ? "-" : row.efoldx,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.efoldx) <= -0.5,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.efoldx) >= 0.5,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'ML pred.',
        name: <span title="Predictions provided by the ML tools.">ML pred.</span>,
        selector: 'eml',
        sortable: true,
        format: (row) => row.eml === null ? "-" : row.eml,
        conditionalCellStyles: [
            {
                when: row => parseFloat(row.eml) >= 0.0,
                style: {
                    color: 'green'
                }
            },
            {
                when: row => parseFloat(row.eml) < 0.0,
                style: {
                    color: 'red'
                }
            },
        ],
    },
    {
        id: 'btc',
        name: <span title="Mutation was identifies by evolutionary approach.">From evolution</span>,
        selector: (row) => String(row.btc),
        format: (row) => row.btc ? "YES" : "NO",
        sortable: true,
    },
    {
        id: 'isHighEnergy',
        name: <span title="Mutation was identifies by energetic approach.">From energy</span>,
        selector: (row) => String(row.isHighEnergy),
        format: (row) => row.isHighEnergy || row.isLowEnergy ? "YES" : "NO",
        sortable: true,
    },
];

const columnsCustomMutant = [
    {
        name: <span title="Chain">Chain</span>,
        selector: 'chain',
        sortable: true,
        compact: true,
        width: '50px',
    },
    {
        name: <span title="Position">Pos</span>,
        selector: 'position',
        sortable: true,
        compact: true,
        width: '37px',
    },
    {
        name: <span title="Original residue">Ref</span>,
        selector: 'residue',
        sortable: true,
        compact: true,
        width: '37px',
    },
    {
        name: <span title="Mutation">Alt</span>,
        selector: 'mutation',
        sortable: true,
        compact: true,
        width: '39px',
    },
];

const columnsEssentialResidues = [
    {
        name: <span title="Chain">Chain</span>,
        selector: (row) => String(row.chain),
        sortable: true,
        compact: true,
        width: '80px',
    },
    {
        name: <span title="Position">Residue position</span>,
        selector: (row) => String(row.residue),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Residue">Residue</span>,
        selector: (row) => String(row.residueName),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="UniProt accession code">Accession code</span>,
        selector: (row) => String(row.referenceEntry),
        sortable: true,
        compact: true,
    },
];

const columnsEssentialResidueDetails = [
    {
        name: <span title="UniProt accession code">Accession code</span>,
        selector: (row) => String(row.referenceEntry),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Identity to the query sequence">Identity</span>,
        selector: (row) => String(row.identity),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Type">Type</span>,
        selector: (row) => String(row.type),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Description">Description</span>,
        selector: (row) => String(row.description),
        sortable: true,
        compact: true,
    },

    {
        name: <span title="Neighbourhood">Neighbourhood</span>,
        selector: (row) => String(row.neighbourhood),
        sortable: true,
        compact: true,
    },
];

const BiologicalUnits = [
    {
        name: <span title="Molecule">Molecule</span>,
        selector: (row) => String(row.molecule),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Chains">Chains</span>,
        selector: (row) => String(row.chains),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Original chains">Original chains</span>,
        selector: (row) => String(row.original),
        sortable: true,
        compact: true,
    },
    {
        name: <span title="Quaternary structure">Quaternary structure</span>,
        selector: (row) => String(row.quaternaryStructure),
        sortable: true,
        compact: true,
    },
];

const BiologicalUnitDetails = [
    {
        name: <span title="Chain">Chain</span>,
        selector: (row) => String(row.chain),
        sortable: true,
        width: '100px',
    },
    {
        name: <span title="Residues">Residues</span>,
        selector: (row) => String(row.residues),
        sortable: true,
        width: '120px',
    },
    {
        name: <span title="Atoms">Atoms</span>,
        selector: (row) => String(row.atoms),
        sortable: true,
        width: '120px',
    },
];

const ChainTableDetails = [
    {
        name: <span title="Chain ID">Chain ID</span>,
        selector: "id",
        sortable: false,
    },
    {
        name: <span title="Original ID">Original ID</span>,
        selector: "orig",
        sortable: false,
    }
]

export {
    columnsBtc,
    columnsLowRisk,
    columnsLowRiskNoFF,
    columnsHighRisk,
    columnsHighRiskNoFF,
    columnsCombinedLowRisk,
    columnsCombinedLowRiskNoFF,
    columnsCombinedHighRisk,
    columnsCombinedHighRiskNoFF,
    columnsAllResidues,
    columnsAllResiduesNoFF,
    columnsAllResiduesTop,
    columnsAllResiduesDown,
    columnsAllResiduesDownNoFF,
    columnsAncestralDesigns,
    columnsCustomMutant,
    columnsEssentialResidues,
    columnsEssentialResidueDetails,
    BiologicalUnits,
    BiologicalUnitDetails,
    ChainTableDetails,
    columnsAncestralDesignTop,
};
